import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_0 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.12 Case 12</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="B"
          assessmentName="challenge_case_12"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 12. This is a negative case. I’m
                beginning at the level of the temporal and occipital regions.
                Bilaterally, distinct white matter tracts are easily
                identifiable on the left as well as on the right.
              </p>
              <p>
                In the occipital region, it may be difficult to clearly
                delineate and identify the white matter tract. It is important
                to review the slices above and below and to follow any areas of
                concern. In this particular case, following along this intense
                activity, it is clear that it becomes a white matter tract on
                the slice superior.
              </p>
              <p>
                A similar pattern is also seen on the right-hand side.
                Therefore, there is no loss of gray-white contrast in either
                occipital region. In addition, in the temporal lobes, no loss of
                gray-white contrast is seen. Entering into the frontal cortices
                bilaterally, distinct fingerlike projections of white matter are
                seen again on the right as well as on the left.
              </p>
              <p>
                Less intense gray-matter activity is also seen adjacent to this
                white matter uptake. There is no loss of gray-white contrast in
                either frontal cortex. Distinct white matter tracts are also
                seen coursing from the front of the brain to the back of the
                brain on the left as well as on the right, as we enter into the
                parietal region, seen here. There is no loss of gray-white
                contrast either in the lateral or posterior aspects of the
                parietal regions. In the medial parietal region, identified
                here, no increased activity is seen.
              </p>
              <p>
                After reviewing all of the slices, the parietal regions show
                normal gray-white contrast. As there is no loss of gray-white
                contrast in any region, this case is negative. If you called
                this case positive, you may want to review the case once again
                in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-11"
          nextLesson="/module-4/module-4-1-13"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1816910934&entry_id=1_jcady000&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_jcady000"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
